import { useSelector } from "react-redux";
import { BASE_PATH } from "./config";
import { store } from "../redux/store";

export const LinkLang = (path = "") => {
    // const { languages } = useSelector(
    //     (s) => s.languages
    // );
        const { languages } = store.getState().languages;


    // const BASE_PATH = "/projects/super-gallery";

    let currentPath = window.location.pathname;

    // Remove basename
    if (currentPath.startsWith(BASE_PATH)) {
        currentPath = currentPath.substring(BASE_PATH.length);
    }

    const segments = currentPath
        .split("/")
        .filter(Boolean);

    // Current language
    const currentLang = languages.some(
        item => item.code === segments[0]
    )
        ? segments[0]
        : "en";

    // Child link
    let childLink = path || "";

    childLink = childLink.replace(/^\/+/, "");


    // Language missing
    return `/${currentLang}/${childLink}`;
};
export const FullLinkLang = (path) => {
    const { languages } = store.getState().languages;

    if (!path) return "";

    // Current language
    let currentPath = window.location.pathname;

    if (BASE_PATH && currentPath.startsWith(BASE_PATH)) {
        currentPath = currentPath.substring(BASE_PATH.length);
    }

    const segments = currentPath
        .split("/")
        .filter(Boolean);

    const currentLang = languages.some(
        item => item.code === segments[0]
    )
        ? segments[0]
        : "en";

    // Full URL
    if (/^https?:\/\//i.test(path)) {
        const url = new URL(path);

        let urlPath = url.pathname;

        // Remove BASE_PATH when testing
        if (BASE_PATH && urlPath.startsWith(BASE_PATH)) {
            urlPath = urlPath.substring(BASE_PATH.length);
        }

        const pathSegments = urlPath
            .split("/")
            .filter(Boolean);

        // Already has language
        const hasLanguage = languages.some(
            item => item.code === pathSegments[0]
        );

        if (!hasLanguage) {
            pathSegments.unshift(currentLang);
        }

        // Add BASE_PATH back
        url.pathname =
            `${BASE_PATH}/${pathSegments.join("/")}`;

        return url.toString();
    }

    return path;
};